import { render, staticRenderFns } from "./PodcastList.vue?vue&type=template&id=770443f2&"
import script from "./PodcastList.vue?vue&type=script&lang=js&"
export * from "./PodcastList.vue?vue&type=script&lang=js&"
import style0 from "./PodcastList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports